import React, { useState } from 'react';

/* Generates N sample means of size n from Uniform(0,1) */
function sampleMeans(n, N) {
  const arr = [];
  for (let i = 0; i < N; i++) {
    let s = 0;
    for (let k = 0; k < n; k++) s += Math.random();
    arr.push(s / n);
  }
  return arr;
}

export default function CLTSimulatorTool({ n = 2, N = 1000 }) {
  const [size, setSize] = useState(n);
  const data = sampleMeans(size, N);

  /* crude binning */
  const bins = Array(20).fill(0);
  data.forEach(v => {
    const idx = Math.min(19, Math.floor(v * 20));
    bins[idx]++;
  });
  const max = Math.max(...bins);

  return (
    <div>
      <label>
        sample size n:&nbsp;
        <input
        className="inputBox"
          type="number"
          min={1}
          max={50}
          value={size}
          onChange={e => setSize(+e.target.value)}
          style={{ width: 60 }}
        />
      </label>

      {/* SVG histogram */}
      <svg width={320} height={160} style={{ border: '1px solid #ccc', marginTop: 6 }}>
        {bins.map((b, i) => (
          <rect
            key={i}
            x={i * 16}
            y={160 - (b / max) * 150}
            width={14}
            height={(b / max) * 150}
            fill="#4D9DE0"
          />
        ))}
      </svg>
      <div style={{ fontSize: 24 }}>
        Histogram of {N} means of size n from Uniform(0,1).
      </div>
    </div>
  );
}
